import { h } from 'preact';
import classNames from 'classnames';

const ColorSwatch = ({ value, soldOut, available, initialChange }) => {
  const colorSwatchClasses = [
    'relative',
    'w-16',
    'h-16',
    'rounded-100',
    'block',
    'hover:ring-2',
    'hover:ring-gray-900',
    'hover:border-2',
    'hover:border-inverse',
    'peer-checked:ring-2',
    'peer-checked:ring-gray-900',
    'peer-checked:border-2',
    'peer-checked:border-inverse',
    'peer-checked:w-16',
    'peer-checked:h-16',
    'peer-disabled:cursor-not-allowed',
    'peer-disabled:ring-gray-800',
    'peer-disabled:ring-2',
    'peer-disabled:border-2',
    'peer-disabled:border-inverse',
    'peer-disabled:after:content-[""]',
    'peer-disabled:after:absolute',
    'peer-disabled:after:w-16',
    'peer-disabled:after:top-[5px]',
    'peer-disabled:after:-left-2',
    'peer-disabled:after:h-2',
    'peer-disabled:after:bg-gray-800',
    'peer-disabled:after:-rotate-45',
  ];

  const mapping = window.TMW?.color_mapping?.[value];

  let color = 'deeppink';

  if (mapping?.master_color === 'WHITE') {
    colorSwatchClasses.push('border', 'border-gray-900');
  }

  if (soldOut || (!available && initialChange)) {
    colorSwatchClasses.push('sold-out-state');
  }

  if (mapping && mapping.color_gradient) {
    color = mapping.color_gradient;
  } else if (mapping && mapping.color_code) {
    color = mapping.color_code;
  }

  return (
    <span
      className={classNames(colorSwatchClasses)}
      style={{ background: color }}
    ></span>
  );
};

export default ColorSwatch;
